import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 72 72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M36 44.85c-.4 0-.775-.063-1.125-.188a2.632 2.632 0 0 1-.975-.637L20.025 30.15c-.55-.55-.813-1.237-.787-2.063.024-.825.312-1.512.862-2.062.55-.55 1.25-.825 2.1-.825.85 0 1.55.275 2.1.825l11.7 11.7L47.775 25.95c.55-.55 1.238-.813 2.063-.787.825.024 1.512.312 2.062.862.55.55.825 1.25.825 2.1 0 .85-.275 1.55-.825 2.1l-13.8 13.8c-.3.3-.625.513-.975.638A3.32 3.32 0 0 1 36 44.85Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "chevron-down"}) } }